import { mediaData } from '@/mocks/comicData';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {mediaData.title}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.items.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/80">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[11px] rounded bg-accent-500 text-background-50 font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaData.items.slice(3).map((item, idx) => (
            <div
              key={idx + 3}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors flex flex-col sm:flex-row"
            >
              <div className="relative sm:w-[240px] flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/80">
                    <i className="ri-play-fill text-primary-500 text-base ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <span className="inline-block px-2 py-0.5 text-[11px] rounded bg-accent-500 text-background-50 font-medium w-fit mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}